import React from 'react'

import { DDSIconDefinition, Flex, Icon, Text } from '@driftt/dds'

interface IconWithCountProps {
  icon: DDSIconDefinition
  count: number
  isButton?: boolean
}

export const IconWithCount = ({ icon, count, isButton }: IconWithCountProps) => (
  <Flex alignItems="center">
    <Icon icon={icon} color={isButton ? 'gray12' : undefined} />
    <Text variant="metadata">{count}</Text>
  </Flex>
)
